// extracted by mini-css-extract-plugin
export default {"content":"Tooltip_content__xmJdw","block":"Tooltip_block__n0xAf","tooltip":"Tooltip_tooltip__pMxpH"};